import ProgressCircles from './ProgressCircles';
import './ProgressCircles.css';

export default ProgressCircles;



// WEBPACK FOOTER //
// ./src/pages/Account/components/ProgressCircles/index.js